import React from 'react';
import { alturasColunas } from './calculos';
import { formataNumero } from './formata';
import './painel.css';

// Colunas verticais em CSS — sem lib de gráfico (chart.js só existe aqui como
// dependência transitiva do mdbreact). Cada coluna é o total (tom claro) com a
// parte destacada embaixo (tom forte). Coluna `incompleto` ganha hachura;
// `destaque` ganha contorno.
//
// O valor fica em TEXTO acima da coluna: o total e, com `formataParte`, a parte
// em azul. Antes ele só existia no `titulo` (tooltip), que não aparece no toque
// nem no foco do teclado — o gráfico não mostrava número nenhum. Em tela
// estreita o rótulo gira e a parte sai do gráfico; "Ver valores" tem tudo, e
// serve também a leitor de tela.
export default function Colunas({
  itens, aoClicar, altura = 160, formata = formataNumero, formataParte, descricao,
}) {
  const alturas = alturasColunas(itens);
  return (
    <>
      <div className="painel-colunas" role="group" aria-label={descricao}>
        {itens.map((item, i) => {
          const classe = [
            'painel-coluna',
            item.incompleto ? 'painel-coluna--incompleta' : '',
            item.destaque ? 'painel-coluna--destaque' : '',
            aoClicar ? 'painel-coluna--clicavel' : '',
          ].join(' ');
          const { total, parte } = alturas[i];
          // Valor pequeno demais para a escala não pode sumir: zero e "quase zero"
          // ficavam iguais.
          const minTotal = Number(item.total) > 0 ? 2 : 0;
          const minParte = Number(item.parte) > 0 ? 2 : 0;
          const corpo = (
            <>
              <span className="painel-coluna__trilho" style={{ height: altura }}>
                <span className="painel-coluna__valor" aria-hidden="true" style={{ bottom: `calc(${total}% + 3px)` }}>
                  <span className="painel-coluna__valor-total">{formata(item.total)}</span>
                  {formataParte ? <span className="painel-coluna__valor-parte">{formataParte(item.parte)}</span> : null}
                </span>
                <span className="painel-coluna__total" style={{ height: `${total}%`, minHeight: minTotal }}>
                  <span
                    className="painel-coluna__parte"
                    style={{ height: `${total ? (100 * parte) / total : 0}%`, minHeight: minParte }}
                  />
                </span>
              </span>
              <span className="painel-coluna__rotulo">{item.rotulo}</span>
            </>
          );
          return aoClicar ? (
            <button key={item.chave} type="button" className={classe} title={item.titulo} aria-label={item.titulo} onClick={() => aoClicar(item)}>
              {corpo}
            </button>
          ) : (
            <div key={item.chave} className={classe} title={item.titulo} role="img" aria-label={item.titulo}>
              {corpo}
            </div>
          );
        })}
      </div>
      <details className="painel-colunas__valores">
        <summary>Ver valores</summary>
        <table className="table table-sm mb-0">
          {descricao ? <caption className="sr-only">{descricao}</caption> : null}
          <tbody>
            {itens.map((item) => (
              <tr key={item.chave}>
                <th scope="row" style={{ whiteSpace: 'nowrap' }}>{item.rotulo}</th>
                <td>{item.titulo}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </details>
    </>
  );
}
